import type { BillHistory } from "../api/reportsBillsHistory";

// „Закриване на сметка(1)" — умишлено нефискализираната сметка В БРОЙ (трите
// клика, право `close_bill_1`). Огледало на `cash_no_receipt_clause()` в
// BE (`app/features/bills/models.py`): closed + total = 0 + метод 1.
//
// `total` се пълни САМО от успешен фискален бон, тоест нулата значи „няма
// касова бележка"; методът отделя трите клика от останалите закрити сметки с
// `total = 0` — „Плащане по сметка", метод „БЕЗ ФИСКАЛИЗИРАНЕ", карта/смесено
// с паднала фискализация. Те са легитимни пари и си остават фактурируеми.
export const CASH_NO_RECEIPT_PAYMENT_METHOD_ID = 1;

/** Закрита в брой без бон — такава сметка НЕ подлежи на фактуриране. */
export const isCashNoReceiptBill = (
  bill: Pick<BillHistory, "status" | "total" | "payment_method_id">,
): boolean =>
  bill.status === "closed" &&
  Number(bill.total ?? 0) === 0 &&
  bill.payment_method_id === CASH_NO_RECEIPT_PAYMENT_METHOD_ID;
